import { updateValidity, markAsDirty, updateValueAndValidity } from './forms-utils';
import { getActivitiesSupport, getActivitiesSupportList } from './get-enum/get-activities-support';
import { enumToList } from './enum-to-list';
import {
  getPerformanceCategoriesSupport,
  getPerformanceCategoriesSupportList,
  getPePerformanceCategoriesSupportList
} from './get-enum/get-performance-categories-support';
import { getQuestionSupport, getQuestionSupportList, getPeQuestionSupportList } from './get-enum/get-question-support';
import { getFormAction, getFormActionList, getPpFormActionList } from './get-enum/get-form-action';
import {
  getResponseType,
  getResponse,
  getResponseList,
  getRace,
  getRaceList,
  getTrainingType,
  getTrainingTypeList,
  getTrainingReportSubject,
  getSiteRole,
  getSiteRoleList,
  getProfileSiteRoleList,
  getRoleList
} from './get-enum';
import { moveInArray } from './move-in-array';
import { makeArray } from './make-array';
import { getQuizQuestionType, getQuizQuestionTypeList } from './get-enum/get-quiz-question-type';
import { getResponseTypeList } from './get-enum/get-response-type';
import { getQuizResponseType, getQuizResponseTypeList } from './get-enum/get-quiz-response-type';
import {
  getProgramRole,
  getProgramRoleList,
  getFtProgramRoleList,
  getPeProgramRoleList,
  getMtProgramRoleList
} from './get-enum/get-program-role';
import { getQuestionType, getQuestionTypeList } from './get-enum/get-question-type';
import { getProgramType, getProgramTypeList, getProgramTypeStringUrl } from './get-enum/get-program-type';
import { getPeFormResponseType, getPeFormResponseTypeList } from './get-enum/get-pe-form-response-type';
import { getPeFormQuestionType, getPeFormQuestionTypeList } from './get-enum/get-pe-form-question-type';
import { getSiteSortField, getSiteSortFieldList } from './get-enum/get-site-sort';
import { getTier, getTiersList } from './get-tier';
import { getAlertType, getAlertTypeList } from './get-enum/get-alert-type';
import { getAlertFrequency, getAlertFrequencyList, getPeAlertFrequencyList } from './get-enum/get-alert-frequency';
import { getPeFormResponse, getPeFormResponseList } from './get-enum/get-pe-form-response';
import { getAssignmentStatus, getAssignmentStatusList } from './get-enum/get-assignment-status';
import { getSkillStatus, getSkillStatusList } from './get-enum/get-skills-status-type';
import {
  getTrendingGroupByOption,
  getTrendingGroupByOptionList
} from 'src/app/shared/utils/get-enum/get-trending-group-by-option';
import { getProgramFilter, getProgramFilterList } from 'src/app/shared/utils/get-enum/get-program-filter';
import { getFormActionBtn, getFormActionBtnList } from 'src/app/shared/utils/get-enum/get-form-action-btn';
import { getDoc, getDocList } from 'src/app/shared/utils/get-enum/get-doc';
import { getImageFormatList, getImageFormat } from 'src/app/shared/utils/get-enum/get-image-format';
import { getDocResources, getDocResourcesList } from 'src/app/shared/utils/get-enum/get-doc-resources';
import {
  getActiveDirectoryType,
  getActiveDirectoryTypeList
} from 'src/app/shared/utils/get-enum/get-active-directory-type';
import { getMaxActiveProgramNumber } from './get-enum/get-max-active-program-number';
import { getIncidentsSupportList, getIncidentsSupport } from './get-enum/get-incidents-support';
import { getFtReportSubjectList, getFtReportSubject } from './get-enum/get-ft-report-subject';
import { getPeReportSubjectList, getPeReportSubject } from './get-enum/get-pe-report-subject';
import { getPpReportSubjectList, getPpReportSubject } from './get-enum/get-pp-report-subject';
import { getMtReportSubjectList, getMtReportSubject } from './get-enum/get-mt-report-subject';
import { getReportStatus, getReportStatusList } from './get-enum/get-report-status';
import { getNumberOfFormInstances, getNumberOfFormInstancesList } from './get-enum/get-number-of-form-instances';
import { getGoalStatusList } from './get-enum/get-goal-status';
import { getAlertEvaluationPeriodList } from './get-enum/get-alert-evaluation-period';
import { getDateCounter } from './get-date-counter';
import { getDueDate, getDueDateList } from './get-enum/get-due-date';
import { getAuditLogComponentList } from './get-enum/get-audit-log-component';
import { getAuditLogEventList } from './get-enum/get-audit-log-event';
import { getDefaultAvatar } from './get-enum/get-default-avatar';
import { getShortDateString } from './get-short-date-string';
import { concatFormNameWithNumber } from './forms-utils';
import { isEndOfElemReached } from './is-end-of-elem-reached';
import { getUserRole } from './get-user-role';

export class CustomUtils {
  public static markAsDirty = markAsDirty;
  public static updateValidity = updateValidity;
  public static updateValueAndValidity = updateValueAndValidity;
  public static enumToList = enumToList;
  public static moveInArray = moveInArray;
  public static makeArray = makeArray;
  public static getShortDateString = getShortDateString;

  public static getIncidentsSupport = getIncidentsSupport;
  public static getIncidentsSupportList = getIncidentsSupportList;
  public static getActivitiesSupport = getActivitiesSupport;
  public static getActivitiesSupportList = getActivitiesSupportList;
  public static getPerformanceCategoriesSupport = getPerformanceCategoriesSupport;
  public static getPerformanceCategoriesSupportList = getPerformanceCategoriesSupportList;
  public static getPePerformanceCategoriesSupportList = getPePerformanceCategoriesSupportList;
  public static getQuestionSupport = getQuestionSupport;
  public static getAlertEvaluationPeriodList = getAlertEvaluationPeriodList;
  public static getQuestionSupportList = getQuestionSupportList;
  public static getPeQuestionSupportList = getPeQuestionSupportList;
  public static getFormAction = getFormAction;
  public static getFormActionList = getFormActionList;
  public static getPpFormActionList = getPpFormActionList;
  public static getResponseType = getResponseType;
  public static getResponseTypeList = getResponseTypeList;
  public static getResponse = getResponse;
  public static getResponseList = getResponseList;
  public static getRace = getRace;
  public static getRaceList = getRaceList;
  public static getQuizQuestionType = getQuizQuestionType;
  public static getQuizQuestionTypeList = getQuizQuestionTypeList;
  public static getQuizResponseType = getQuizResponseType;
  public static getQuizResponseTypeList = getQuizResponseTypeList;
  public static getUserRole = getUserRole;
  public static getProgramRole = getProgramRole;
  public static getProgramRoleList = getProgramRoleList;
  public static getFtProgramRoleList = getFtProgramRoleList;
  public static getPeProgramRoleList = getPeProgramRoleList;
  public static getMtProgramRoleList = getMtProgramRoleList;
  public static getSiteRole = getSiteRole;
  public static getSiteRoleList = getSiteRoleList;
  public static getProfileSiteRoleList = getProfileSiteRoleList;
  public static getRoleList = getRoleList;
  public static getQuestionType = getQuestionType;
  public static getQuestionTypeList = getQuestionTypeList;
  public static getProgramType = getProgramType;
  public static getProgramTypeStringUrl = getProgramTypeStringUrl;
  public static getProgramTypeList = getProgramTypeList;
  public static getPeFormResponseType = getPeFormResponseType;
  public static getPeFormResponseTypeList = getPeFormResponseTypeList;
  public static getPeFormQuestionType = getPeFormQuestionType;
  public static getPeFormQuestionTypeList = getPeFormQuestionTypeList;
  public static getSiteSortField = getSiteSortField;
  public static getSiteSortFieldList = getSiteSortFieldList;
  public static getTier = getTier;
  public static getTiersList = getTiersList;
  public static getAlertType = getAlertType;
  public static getAlertTypeList = getAlertTypeList;
  public static getAlertFrequency = getAlertFrequency;
  public static getAlertFrequencyList = getAlertFrequencyList;
  public static getPeAlertFrequencyList = getPeAlertFrequencyList;
  public static getPeFormResponse = getPeFormResponse;
  public static getPeFormResponseList = getPeFormResponseList;
  public static getTrainingType = getTrainingType;
  public static getTrainingTypeList = getTrainingTypeList;
  public static getAssignmentStatus = getAssignmentStatus;
  public static getAssignmentStatusList = getAssignmentStatusList;
  public static getSkillStatus = getSkillStatus;
  public static getSkillStatusList = getSkillStatusList;
  public static getTrendingGroupByOption = getTrendingGroupByOption;
  public static getTrendingGroupByOptionList = getTrendingGroupByOptionList;
  public static getProgramFilter = getProgramFilter;
  public static getProgramFilterList = getProgramFilterList;
  public static getFormActionBtn = getFormActionBtn;
  public static getFormActionBtnList = getFormActionBtnList;
  public static getDoc = getDoc;
  public static getDocList = getDocList;
  public static getDocResources = getDocResources;
  public static getDocResourcesList = getDocResourcesList;
  public static getImageFormat = getImageFormat;
  public static getImageFormatList = getImageFormatList;
  public static getActiveDirectoryType = getActiveDirectoryType;
  public static getActiveDirectoryTypeList = getActiveDirectoryTypeList;
  public static getMaxActiveProgramNumber = getMaxActiveProgramNumber;
  public static getFtReportSubject = getFtReportSubject;
  public static getFtReportSubjectList = getFtReportSubjectList;
  public static getPeReportSubject = getPeReportSubject;
  public static getPeReportSubjectList = getPeReportSubjectList;
  public static getPpReportSubject = getPpReportSubject;
  public static getPpReportSubjectList = getPpReportSubjectList;
  public static getMtReportSubject = getMtReportSubject;
  public static getMtReportSubjectList = getMtReportSubjectList;
  public static getReportStatus = getReportStatus;
  public static getReportStatusList = getReportStatusList;
  public static getNumberOfFormInstances = getNumberOfFormInstances;
  public static getNumberOfFormInstancesList = getNumberOfFormInstancesList;
  public static getGoalStatusList = getGoalStatusList;
  public static getAuditLogAreaList = getAuditLogComponentList;
  public static getAuditLogEventList = getAuditLogEventList;
  public static getDateCounter = getDateCounter;
  public static getDueDate = getDueDate;
  public static getDueDateList = getDueDateList;
  public static getDefaultAvatar = getDefaultAvatar;
  public static getTrainingReportSubject = getTrainingReportSubject;
  public static concatFormNameWithNumber = concatFormNameWithNumber;
  public static isEndOfElemReached = isEndOfElemReached;
}
